// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"68d66cc6","237":"d895525a","343":"f3d3bdcd","440":"cb403b12","441":"731ab892","451":"e0cad89c","453":"5f7068e0","525":"d304a21d","572":"77bc6ed3","650":"e7cd72b3","822":"e9917622","931":"6a2187b6","971":"a5465a2f"}[chunkId] + ".chunk.js";
};